import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import Table from 'rc-table'
import moment from 'moment'
import Dropdown from 'react-dropdown'
import { api, showToastAction } from '../../store'
import { Divider, EInputTemplate, Input } from '../../components'
import { useTypedSelector, useValidation } from '../../hooks'
import { Assets } from '../../assets'
import {
  createCategoriesAdsAction,
  deleteCategoriesAdsAction,
  getCategoriesAdsAction,
  getSubCategoriesAdsAction,
  updateCategoriesAdsAction,
} from '../../store/categoriesAds'
import { Modal } from '../../components/Modal'
import { PhotoPicker } from '../../components/PhotoPicker'
import { useTranslation } from 'react-i18next'

import {
  Header,
  StyledHeader,
  StyledRow,
  StyledTable,
  TableWrapper,
  Title,
  StyledPagination,
  StyledButtonEnd,
  StyledButton,
  FullWidth,
  StyledEntity,
  Image,
  StyledSort,
  HeaderTitle,
  HeaderModal,
  FooterModal,
  ButtonCreate,
  ButtonDelete,
  ButtonUpdate,
  Close,
  NavigateButton,
  BodyModal,
  PhotoCategory,
  StyledWrapper,
  Error,
  ErrorBlock,
} from './styled'
import { PAGE_LiMIT, languages } from './consts'
import useSWR from 'swr'
import { Service } from '../../services'
import { generateErrorToast } from '../../helpers'

export const CategoriesTab = () => {
  const [typeModal, setTypeModal] = useState<string | null>(null)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [cateoriesArray, setCategoriesArray] = useState<any>([])
  const [searchPage, setSearchPage] = useState<number>(1)
  const [currentData, setCurrentData] = useState<any>(null)
  const [formData, setFormData] = useState<{
    titleUk: string
    titleEn: string
    photo: null | File
  }>({
    titleUk: '',
    titleEn: '',
    photo: null,
  })
  const { language: lang } = useTypedSelector(state => state.user)
  const { t } = useTranslation('categories')

  const { data: subcategories } = useSWR(
    [
      'get-subcategories',
      currentData?._id
        ? { category: currentData?._id }
        : { limit: 10, page: currentPage },
    ],
    ([_, key]) => Service.Subcategory.getSubcategories(key),
    { revalidateOnFocus: false },
  )

  const { data: advices } = useSWR(
    [
      'get-advices',
      currentData?._id
        ? { category: currentData?._id }
        : { limit: 10, page: currentPage },
    ],
    ([_, key]) => Service.Advice.getAdvices(key),
    { revalidateOnFocus: false },
  )

  const [language, setLanguage] = useState<string>(lang || 'uk')

  useEffect(() => {
    setLanguage(lang)
  }, [lang])

  const dispatch = useDispatch()

  const { totalCount, categoriesAds, response, subCategoryTotalCount } =
    useTypedSelector(state => state.categories)

  const schema = useMemo<any>(
    () => ({
      titleUk: {
        condition: !!formData.titleUk,
        error: `${t('enterTheTitleOn')} uk`,
      },
      photo: {
        condition: !!formData.photo,
        error: t('selectPhoto'),
      },
    }),
    [formData],
  )

  console.log(schema, 'schema')

  const {
    validationSchema,
    validation,
    enableValidation,
    isEnabled,
    disableValidation,
    //eslint-disable-next-line
  } = useValidation(schema)

  const columns = [
    {
      title: <div>{t('name')}</div>,
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: <div>{t('photo')}</div>,
      dataIndex: 'image',
      key: 'image',
    },
    {
      title: (
        <StyledSort>
          <div>{t('creationDate')}</div>

          <Divider width={10} />
        </StyledSort>
      ),
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: t('moreDetails'),
      dataIndex: 'details',
      key: 'details',
    },
  ]

  const choosePage = (page: number) => {
    dispatch(
      getCategoriesAdsAction.request({
        page: page === 0 ? 1 : page,
        limit: PAGE_LiMIT,
        sortBy: '',
      }),
    )
    setCurrentPage(page === 0 ? 1 : page)
  }

  const putSearchPage = (e: React.SyntheticEvent<Element, Event> | any) => {
    setSearchPage(isNaN(+e.target.value) ? 1 : +e.target.value)
  }

  const enterKeyPress = (e: any) => {
    e?.code === 'Enter' &&
      choosePage(
        searchPage <=
          (totalCount === 0 ? 1 : Math.ceil(totalCount / PAGE_LiMIT))
          ? searchPage !== currentPage
            ? searchPage
            : 1
          : 1,
      )
  }

  const createCategories = async () => {
    enableValidation()
    await validation()

    const data = new FormData()

    if (formData.photo) {
      data.append('image', formData.photo)
    }
    if (formData.titleUk) {
      data.append(
        'title',
        JSON.stringify(
          [
            { lang: 'uk', value: formData.titleUk },
            { lang: 'en', value: formData.titleEn },
          ].filter(item => item.value),
        ),
      )
    }

    dispatch(createCategoriesAdsAction.request({ data }))
    disableValidation()
  }

  const updateCategories = async () => {
    enableValidation()
    await validation()

    const data = new FormData()

    data.append(
      'title',
      JSON.stringify(
        [
          { lang: 'uk', value: formData.titleUk },
          { lang: 'en', value: formData.titleEn },
        ].filter(item => item.value),
      ),
    )
    if (typeof formData.photo !== 'string') {
      data.append('image', formData.photo as File)
    }

    dispatch(updateCategoriesAdsAction.request({ id: currentData._id, data }))
    disableValidation()
  }

  const deleteCategories = () => {
    if (subcategories && subcategories?.totalCount > 0) {
      dispatch(
        showToastAction.request(
          generateErrorToast(
            "Не можна видалити категорію до якої прив'язані пости чи оголошення",
          ),
        ),
      )

      return
    }

    if (advices && advices?.totalCount > 0) {
      dispatch(
        showToastAction.request(
          generateErrorToast(
            "Не можна видалити категорію до якої прив'язані пости чи оголошення",
          ),
        ),
      )

      return
    }

    if (subCategoryTotalCount > 0) {
      dispatch(
        showToastAction.request(
          generateErrorToast(
            "Не можна видалити категорію до якої прив'язані пости чи оголошення",
          ),
        ),
      )

      return
    }
    dispatch(deleteCategoriesAdsAction.request({ id: currentData._id }))
  }

  const handleInputChange = (e: any) => {
    const { value, name } = e.target as HTMLInputElement
    setFormData({ ...formData, [name]: value })
  }

  const handlePhotoChange = (file: File | null) => {
    setFormData({ ...formData, photo: file })
  }

  const getCategories = (name?: string) => {
    dispatch(
      getCategoriesAdsAction.request({
        page: currentPage === 0 ? 1 : currentPage,
        limit: PAGE_LiMIT,
        sortBy: 'createdAt',
      }),
    )
  }

  const getSubCategories = () => {
    dispatch(
      getSubCategoriesAdsAction.request({
        page: currentPage === 0 ? 1 : currentPage,
        limit: PAGE_LiMIT,
        category: currentData?._id,
      }),
    )
  }
  // eslint-disable-next-line
  useEffect(() => {
    getCategories()
  }, [])

  useEffect(() => {
    if (
      response === 'CREATE_CATEGORIES' ||
      response === 'UPDATE_CATEGORIES' ||
      response === 'DELETE_CATEGORIES'
    ) {
      setTypeModal('')
      setFormData({
        photo: null,
        titleUk: '',
        titleEn: '',
      })
      getCategories()
    }
  }, [response])

  const openCurrentCategory = (data: any) => {
    setTypeModal('update')
    setCurrentData(data)
  }

  const closeModal = () => {
    setTypeModal(null)
    setCurrentData(null)
    setFormData({
      photo: null,
      titleUk: '',
      titleEn: '',
    })
  }

  useEffect(() => {
    setCategoriesArray(
      categoriesAds?.map((c: any) => ({
        image: (
          <PhotoCategory
            src={`${api.withImageAPI}/ads-categories/${c?.image}`}
            alt="categories-image"
          />
        ),
        //@ts-ignore
        title: c?.title?.find(item => item?.lang == lang)?.value ?? '-',
        createdAt: moment(c?.createdAt).isValid()
          ? moment(c?.createdAt).format('HH:mm DD.MM.YYYY')
          : '-',
        key: c?.id,
        details: (
          <NavigateButton onClick={() => openCurrentCategory(c)}>
            {t('moreDetails')}
          </NavigateButton>
        ),
      })),
    )
  }, [categoriesAds, t])

  useEffect(() => {
    if (currentData) {
      setFormData((prevState: any) => ({
        ...prevState,
        //@ts-ignore
        titleUk: currentData?.title?.find(item => item.lang == 'uk')?.value,
        //@ts-ignore
        titleEn: currentData?.title?.find(item => item.lang == 'en')?.value,
        photo: `${api.withImageAPI}/ads-categories/${currentData?.image}`,
      }))
    }
  }, [currentData])

  useEffect(() => {
    getSubCategories()
  }, [currentData?._id])

  const changeType = (type: string) => {
    setLanguage(type)
  }

  return (
    <>
      <div>
        <Header>
          <Title>{`${t('adsCategories')} (${totalCount})`}</Title>
          <StyledPagination>
            <StyledEntity onKeyPress={enterKeyPress}>
              <Input
                label={t('page')}
                name="searchPage"
                value={searchPage.toString()}
                placeholder={t('page')}
                template={EInputTemplate.NAME}
                onChange={putSearchPage}
              />
            </StyledEntity>
            <Divider width={10} />
            <Image
              src={Assets.SEARCH_ICON}
              onClick={() =>
                choosePage(
                  searchPage <=
                    (totalCount === 0 ? 1 : Math.ceil(totalCount / PAGE_LiMIT))
                    ? searchPage
                    : 1,
                )
              }
            />
          </StyledPagination>
          <ButtonCreate onClick={() => setTypeModal('create')}>
            {t('create')}
          </ButtonCreate>
        </Header>

        <Divider height={30} />

        <TableWrapper>
          <Table
            columns={columns}
            data={cateoriesArray}
            scroll={{ y: 650 }}
            components={{
              body: {
                row: StyledRow,
              },
              header: {
                cell: StyledHeader,
              },
              table: StyledTable,
            }}
          />
        </TableWrapper>

        <Divider height={20} />
      </div>

      <FullWidth>
        <StyledPagination>
          {currentPage === 1 ? (
            <StyledButtonEnd>{t('clinics:back')}</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => choosePage(currentPage - 1)}>
              {t('clinics:back')}
            </StyledButton>
          )}

          <div>
            {currentPage}/
            {!totalCount
              ? 1
              : Math.ceil(totalCount / PAGE_LiMIT) === 0
              ? 1
              : Math.ceil(totalCount / PAGE_LiMIT)}
          </div>

          {currentPage ===
          (!totalCount ? 1 : Math.ceil(totalCount / PAGE_LiMIT)) ? (
            <StyledButtonEnd>{t('clinics:next')}</StyledButtonEnd>
          ) : (
            <StyledButton onClick={() => choosePage(currentPage + 1)}>
              {t('clinics:next')}
            </StyledButton>
          )}
        </StyledPagination>
        <Divider height={10} />
      </FullWidth>
      {typeModal && (
        <Modal>
          <HeaderModal>
            <HeaderTitle>
              {typeModal === 'create'
                ? t('createCategory')
                : t('updateCategory')}
            </HeaderTitle>
            <Close onClick={closeModal}>&#x2716;</Close>
          </HeaderModal>
          <BodyModal>
            <StyledWrapper>
              <Dropdown
                options={languages}
                onChange={option => changeType(option.value)}
                value={language}
                placeholder={t('selectLanguage')}
              />
            </StyledWrapper>

            {language === 'uk' && (
              <Input
                label={`${t('title')} - uk`}
                name="titleUk"
                value={formData.titleUk}
                placeholder={t('enterName')}
                template={EInputTemplate.NAME}
                onChange={handleInputChange}
              />
            )}
            <ErrorBlock>
              {!(!isEnabled || validationSchema.titleUk) && (
                <Error>{schema.titleUk.error}</Error>
              )}
            </ErrorBlock>
            {language === 'en' && (
              <Input
                label={`${t('title')} - uk`}
                name="titleEn"
                value={formData.titleEn}
                placeholder={t('enterName')}
                template={EInputTemplate.NAME}
                onChange={handleInputChange}
              />
            )}
            <PhotoPicker
              width={415}
              height={150}
              onChange={handlePhotoChange}
              value={formData.photo ? formData.photo : undefined}
            />
            {!(!isEnabled || validationSchema.photo) && (
              <Error>{schema.photo.error}</Error>
            )}
          </BodyModal>
          <FooterModal>
            {typeModal === 'create' ? (
              <ButtonCreate onClick={createCategories}>
                {t('create')}
              </ButtonCreate>
            ) : (
              <>
                <ButtonDelete onClick={deleteCategories}>
                  {t('delete')}
                </ButtonDelete>
                <ButtonUpdate onClick={updateCategories}>
                  {t('update')}
                </ButtonUpdate>
              </>
            )}
          </FooterModal>
        </Modal>
      )}
    </>
  )
}
